import { useState, type FunctionComponent, type ReactNode } from 'react';

import { ArrowDown } from '@/core/tamagoshi/icons/ArrowDown';
import { ArrowUp } from '@/core/tamagoshi/icons/ArrowUp';
import { Typography } from '@/domains/core/tamagoshiTailwind/components/Typography/Typography';

export const Accordion: FunctionComponent<{
  title: string;
  children: ReactNode;
  isExpandable?: boolean;
}> = ({ title, children, isExpandable = true }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>
      <button
        className={`flex w-full justify-between border-0 bg-transparent p-0
          text-left text-foundation-inverted`}
        onClick={() => setIsExpanded(!isExpanded)}
        type="button"
        aria-expanded={isExpanded}
      >
        <span className={'mb-s w-full text-foundation-inverted'}>
          <Typography scale="body1" weight="bold">
            {title}
          </Typography>
        </span>
        {isExpandable &&
          (isExpanded ? (
            <ArrowUp className={'desktop:hidden'} />
          ) : (
            <ArrowDown className={'desktop:hidden'} />
          ))}
      </button>
      <div
        className={`${isExpandable && !isExpanded ? 'hidden desktop:flex' : ''}`}
      >
        {children}
      </div>
    </>
  );
};

Accordion.displayName = 'Accordion';
